import { TokenList } from "../../store/global/getAllTokenLists";
import { CounterParty } from "../tradeUtils";
import { Balances } from "../../store/global/getBalancesFast";
import { Hash } from "viem";
import { getTokenTicker } from "../tokenUtils";
import { getUnselectedTokens, sortTokens } from "../tokenSelectorUtils";
import { TokenListMetadata } from "../../hooks/queries/tokens-queries";
import { Chain } from "wagmi";

enum FilterSuccessReason {
  SearchIsSymbolSubstr = "SearchIsSymbolSubstr",
  SearchIsNameSubstr = "SearchIsNameSubstr",
  SearchIsContractAddress = "SearchIsContractAddress",
}

export const getSearchFilterSuccessReason = ({
  tokenTicker,
  name,
  searchString,
}: {
  tokenTicker: string;
  name: string;
  searchString: string;
}) => {
  if (searchString === "") return true;
  const symbolLowerCase = tokenTicker.toLowerCase();
  const nameLowerCase = name.toLowerCase();
  const stringLowerCase = searchString.toLowerCase();

  if (symbolLowerCase.includes(stringLowerCase)) {
    return FilterSuccessReason.SearchIsSymbolSubstr;
  } else if (nameLowerCase.includes(stringLowerCase)) {
    return FilterSuccessReason.SearchIsNameSubstr;
  }
  // else if (searchString.toLowerCase() === contractAddressLowered) {
  //   return FilterSuccessReason.SearchIsContractAddress;
  // }
  return null;
};
export const getAutoCompleteString = (
  searchString: string,
  tokenList: TokenList | undefined,
  tokensToShow: Array<Hash>
) => {
  if (searchString.length > 0 && tokenList != null && tokensToShow?.[0] != null) {
    const searchStringLowerCase = searchString.toLowerCase();
    const tokenAddress = tokensToShow[0];
    const name = tokenList[tokenAddress]?.name ?? "";
    const ticker = tokenList[tokenAddress].ticker;
    const searchFilterSuccessReason = getSearchFilterSuccessReason({
      tokenTicker: ticker,
      name: ticker,
      searchString,
    });
    if (
      searchFilterSuccessReason === FilterSuccessReason.SearchIsSymbolSubstr &&
      searchStringLowerCase === name.slice(0, searchString.length).toLowerCase()
    ) {
      return searchString + name.slice(searchString.length);
    } else if (
      searchFilterSuccessReason === FilterSuccessReason.SearchIsNameSubstr &&
      searchStringLowerCase === name.slice(0, searchString.length).toLowerCase()
    ) {
      return searchString + name.slice(searchString.length);
    }
  }
};

export const getPlaceholder = (
  counterParty: CounterParty,
  isInFocus: boolean,
  isFirstInCounterparty: boolean
) => {
  if (isInFocus || !isFirstInCounterparty) return "Search for token";
  if (counterParty === "taker") return "Trade this...";
  return "to that...";
};

export const sortTokensByBusinessLogic = (
  makerTokens: Array<Hash>,
  takerTokens: Array<Hash>,
  tokenList: TokenList | undefined,
  tokenListMetadata: TokenListMetadata | undefined,
  balances: Balances,
  searchString: string,
  chain: Chain
) => {
  const unselectedTokensSet = new Set(getUnselectedTokens(tokenList, makerTokens, takerTokens)); // filteredTokens is an array of tokens without tokens that are already selected
  const sortedTokens = sortTokens(balances, chain, tokenList, tokenListMetadata);
  return sortedTokens
    .filter(entry => unselectedTokensSet.has(entry.tokenAddress))
    .map(entry => ({
      tokenAddress: entry.tokenAddress,
      name: tokenList?.[entry.tokenAddress]?.name ?? "",
      contractAddress: (tokenList?.[entry.tokenAddress]?.chainInfo.contractAddress as Hash) ?? "",
    }))
    .filter(
      ({ tokenAddress, name, contractAddress }) =>
        getSearchFilterSuccessReason({
          tokenTicker: getTokenTicker(tokenAddress, tokenList),
          name,
          searchString,
        }) != null
    )
    .map(entry => entry.tokenAddress);
};
